import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Navigation } from "./components/navigation";
import { SoftwareConsultingPage } from "./SoftwareConsultingPage"; // Fixed import path
import { Contact } from "./components/contact";
import { ProductCataloguePage } from "./ProductCataloguePage";
import { UltrasonicDeepfryerVSeries } from "./products/UltrasonicDeepfryerVSeries";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <div>
        <Navigation />
        <Routes>
          {/* Redirect root to Software Consulting */}
          <Route path="/" element={<Navigate to="/software-consulting" replace />} />
          {/* Product Catalogue Section */}
          <Route path="/product-catalogue" element={<ProductCataloguePage data={landingPageData} />} />
          <Route path="/product-catalogue/ultrasonic-deepfryer-ef-v-series" element={<UltrasonicDeepfryerVSeries data={landingPageData} />} />
          {/* Software Consulting Section */}
          <Route path="/software-consulting/*" element={<SoftwareConsultingPage data={landingPageData} />} />
          <Route path="/contact" element={<Contact data={landingPageData.Contact} />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
